import { jsxs as T, Fragment as P, jsx as l } from "react/jsx-runtime";
import { FileSelectorModal as X } from "@systemeio/file-manager";
import { Tooltip as h, FormInput as Z } from "@systemeio/ui";
import { CheckIcon as $ } from "@systemeio/ui/icons";
import { useEditorState as ee } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useState as A, useRef as q, useEffect as N, useCallback as R } from "react";
import { twJoin as a, twMerge as ne } from "tailwind-merge";
import { ToolbarButton as p } from "../../components/content-controls/toolbar-button.mjs";
import { TOOLTIP_STYLES as M, getToolbarIconClassName as ie } from "../../constants/default-styles.mjs";
import { useTranslation as le } from "../../i18n.mjs";
import te from "../../icons/caption-icon.mjs";
import oe from "../../icons/heading-icon.mjs";
import ae from "../../icons/image-centered-icon.mjs";
import re from "../../icons/image-inline-icon.mjs";
import ce from "../../icons/image-side-icon.mjs";
import se from "../../icons/link-icon.mjs";
import me from "../../icons/phone-size-icon.mjs";
import { LinkBubbleEdit as de, LinkBubbleView as ue } from "../link-extension/link-bubble-state.mjs";
import { ImageBubbleMenuState as n, ImageModeEnum as c } from "./image-enum.mjs";
import { isImageSelected as pe } from "./utils/is-image-selected.mjs";
import { BubbleMenu as be } from "../../components/bubble-menu/BubbleMenu.mjs";
const V = (i) => ({
  [n.EditAltMode]: (i == null ? void 0 : i.alt) ?? "",
  [n.EditLinkMode]: (i == null ? void 0 : i.href) ?? "",
  [n.EditCaptionMode]: (i == null ? void 0 : i.caption) ?? ""
}), fe = (i) => i === n.EditAltMode || i === n.EditCaptionMode || i === n.EditLinkMode, he = (i, g) => i[n.EditAltMode] === g[n.EditAltMode] && i[n.EditLinkMode] === g[n.EditLinkMode] && i[n.EditCaptionMode] === g[n.EditCaptionMode], We = ({ editor: i, fileSource: g }) => {
  const { t: s } = le(), [y, _] = A(V()), [m, d] = A(
    n.InitialMode
  ), [W, F] = A(!1), [k, H] = A(!1), O = q(n.InitialMode), C = q({
    alt: null,
    href: null,
    caption: null
  }), t = ee({
    editor: i,
    selector: ({ editor: e }) => {
      var j;
      const o = e == null ? void 0 : e.state, u = o == null ? void 0 : o.selection.from, r = (j = o == null ? void 0 : o.doc.nodeAt(u ?? 0)) == null ? void 0 : j.type.name;
      return {
        from: u,
        node: r,
        imageMode: r ? e == null ? void 0 : e.getAttributes(r).imageMode : null,
        isMobileFullWidth: r ? e == null ? void 0 : e.getAttributes(r).isMobileFullWidth : !1,
        alt: r ? e == null ? void 0 : e.getAttributes(r).alt : null,
        href: r ? e == null ? void 0 : e.getAttributes(r).href : null,
        caption: r ? e == null ? void 0 : e.getAttributes(r).caption : null
      };
    }
  }), z = t == null ? void 0 : t.from, v = t == null ? void 0 : t.node, b = (t == null ? void 0 : t.imageMode) ?? null, w = (t == null ? void 0 : t.isMobileFullWidth) ?? !1, I = (t == null ? void 0 : t.alt) ?? null, f = (t == null ? void 0 : t.href) ?? null, E = (t == null ? void 0 : t.caption) ?? null;
  N(() => {
    O.current = m;
  }, [m]), N(() => {
    C.current = {
      alt: I,
      href: f,
      caption: E
    };
  }, [I, f, E]);
  const L = R((e) => {
    _(
      (o) => he(o, e) ? o : e
    );
  }, []);
  N(() => {
    d(n.InitialMode);
    const e = V(C.current);
    L(e);
  }, [z, L]), N(() => {
    const e = V({
      alt: I,
      href: f,
      caption: E
    });
    L(e);
  }, [I, f, E, L]);
  const x = R(
    (e) => v ? (i == null || i.chain().focus().updateAttributes(v, e).run(), !0) : !1,
    [i, v]
  ), B = R(
    (e) => {
      i == null || i.chain().focus().toggleImageMode(e).run();
    },
    [i]
  );
  if (!i || !(i != null && i.options.editable)) return null;
  const D = (e, o) => {
    _((u) => ({ ...u, [e]: o }));
  }, S = (e, o) => {
    e === n.InitialMode || e === n.ViewLinkMode || x({ [e]: o }) && d(n.InitialMode);
  }, J = (e) => {
    x({ [e]: null }) && d(n.InitialMode);
  }, K = () => {
    b === c.Inline && B(c.BlockCenter), setTimeout(() => {
      d(n.EditCaptionMode);
    }, 0);
  }, Y = () => {
    x({ isMobileFullWidth: !w });
  }, G = (e) => {
    switch (e) {
      case n.EditAltMode:
        return C.current.alt ?? "";
      case n.EditCaptionMode:
        return C.current.caption ?? "";
      case n.EditLinkMode:
        return C.current.href ?? "";
      default:
        return "";
    }
  }, Q = () => {
    switch (m) {
      case n.ViewLinkMode:
        return /* @__PURE__ */ l(
          ue,
          {
            href: y[n.EditLinkMode],
            unsetLink: () => J(n.EditLinkMode),
            setIsEditing: () => d(n.EditLinkMode)
          }
        );
      case n.EditLinkMode:
        return /* @__PURE__ */ l(
          de,
          {
            initialValue: y[n.EditLinkMode],
            onSaveLink: (e) => S(n.EditLinkMode, e),
            openFileSelector: () => {
              F(!0);
            }
          },
          y[n.EditLinkMode]
        );
      case n.EditCaptionMode:
      case n.EditAltMode: {
        const e = y[m];
        let o = "";
        switch (m) {
          case n.EditCaptionMode: {
            o = s("caption");
            break;
          }
          case n.EditAltMode:
            o = s("alt_text");
            break;
        }
        return /* @__PURE__ */ T(P, { children: [
          /* @__PURE__ */ l(
            Z,
            {
              placeholder: o,
              value: e,
              onChange: (u) => D(m, u.target.value)
            }
          ),
          /* @__PURE__ */ l(p, { type: "submit", onClick: () => S(m, e), children: /* @__PURE__ */ l($, { className: ie(!1) }) })
        ] });
      }
      case n.InitialMode:
      default:
        return /* @__PURE__ */ T(P, { children: [
          /* @__PURE__ */ l(
            h,
            {
              label: s("image_in_line"),
              anchor: "left",
              disabled: k,
              ...M,
              children: /* @__PURE__ */ l(
                p,
                {
                  onClick: () => B(c.Inline),
                  className: a(b === c.Inline && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ l(
                    re,
                    {
                      className: a(
                        b === c.Inline ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                        "main-transition-colors"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ l(
            h,
            {
              label: s("image_center"),
              anchor: "left",
              disabled: k,
              ...M,
              children: /* @__PURE__ */ l(
                p,
                {
                  onClick: () => B(c.BlockCenter),
                  className: a(b === c.BlockCenter && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ l(
                    ae,
                    {
                      className: a(
                        b === c.BlockCenter ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                        "main-transition-colors"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ l(h, { label: s("image_side"), anchor: "left", disabled: k, ...M, children: /* @__PURE__ */ l(
            p,
            {
              onClick: () => B(c.BlockRight),
              className: a(b === c.BlockRight && "bg-brand-primary/10"),
              children: /* @__PURE__ */ l(
                ce,
                {
                  className: a(
                    b === c.BlockRight ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                    "main-transition-colors"
                  )
                }
              )
            }
          ) }),
          /* @__PURE__ */ l(
            h,
            {
              disabled: k,
              label: s("image_change_alt_text"),
              anchor: "left",
              ...M,
              children: /* @__PURE__ */ l(
                p,
                {
                  onClick: () => d(n.EditAltMode),
                  className: a(!!I && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ l(
                    oe,
                    {
                      className: a(
                        "main-transition-colors",
                        I ? "stroke-brand-primary" : "stroke-text-primary group-hover:stroke-brand-primary"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ l(h, { label: s("image_change_caption"), anchor: "left", ...M, children: /* @__PURE__ */ l(
            p,
            {
              className: a(!!E && "bg-brand-primary/10"),
              onClick: K,
              children: /* @__PURE__ */ l(
                te,
                {
                  className: a(
                    E ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                    "main-transition-colors"
                  )
                }
              )
            }
          ) }),
          /* @__PURE__ */ l(
            h,
            {
              disabled: k,
              label: s("image_change_link"),
              anchor: "left",
              ...M,
              children: /* @__PURE__ */ l(
                p,
                {
                  className: a("main-transition-colors", !!f && "bg-brand-primary/10"),
                  onClick: () => d(
                    f ? n.ViewLinkMode : n.EditLinkMode
                  ),
                  children: /* @__PURE__ */ l(
                    se,
                    {
                      className: a(
                        "main-transition-colors",
                        f ? "stroke-brand-primary" : "stroke-text-primary group-hover:stroke-brand-primary"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ l(
            h,
            {
              disabled: k,
              label: s("image_change_mobile_full_width"),
              anchor: "left",
              ...M,
              children: /* @__PURE__ */ l(
                p,
                {
                  className: a(
                    "main-transition-colors",
                    w && "bg-brand-primary/10"
                  ),
                  onClick: Y,
                  children: /* @__PURE__ */ l(
                    me,
                    {
                      className: a(
                        "main-transition-colors",
                        w ? "stroke-brand-primary" : "stroke-text-primary group-hover:stroke-brand-primary"
                      )
                    }
                  )
                }
              )
            }
          )
        ] });
    }
  }, U = (e) => {
    if (fe(e)) {
      const o = G(e);
      _((u) => ({
        ...u,
        [e]: o
      }));
    }
  };
  return /* @__PURE__ */ T(P, { children: [
    /* @__PURE__ */ l(
      be,
      {
        className: a(W && "hidden"),
        editor: i,
        pluginKey: "imageBubbleMenu",
        options: {
          onHide: () => {
            const e = O.current;
            U(e), d(n.InitialMode), H(!0);
          },
          onShow: () => {
            H(!1);
          }
        },
        shouldShow: ({ editor: e }) => pe(e),
        children: /* @__PURE__ */ l(
          "form",
          {
            onSubmit: (e) => e.preventDefault(),
            className: ne(
              "flex items-center p-2",
              m === n.InitialMode && "gap-0.5"
            ),
            children: Q()
          }
        )
      }
    ),
    /* @__PURE__ */ l(
      X,
      {
        uploadingFromSource: g,
        initialSearchFilters: {
          source: [g],
          name: "",
          type: []
        },
        opened: W,
        onClose: () => F(!1),
        onSelect: (e) => {
          S(n.EditLinkMode, e.path), F(!1);
        }
      }
    )
  ] });
};
export {
  We as ImageBubbleMenu
};
